import classNames from "classnames";
import { Tag } from "primereact/tag";
import React from "react";
import { DATETIME_FORMATS } from "../../constants/datetime-formats";
import { formatDateV2 } from "../../helpers/dateTimeHelper";
import { getI18nLanguageFromLocalStorage } from "../../helpers/localStorageHelper";
import { modifyMediaUrl } from "../../helpers/modifyMediaUrl";
import { useScrollRestore } from "../../hook/useScrollRestore";
import { EVENTS_PAGE } from "../../constants/app-constants";

export default function EventCard({ data, isExpired, trans }) {
  const { saveScrollPosition } = useScrollRestore(EVENTS_PAGE.EVENTS_SCROLL_POSITION);

  const remainLabel = () => (isExpired ? trans?.eventEndedLabel : `D-${data.daysRemaining}`);

  const startDateLabel = data?.startDate ? formatDateV2(data.startDate, DATETIME_FORMATS.YYYYdotMMdotDD) : "";
  const endDateLabel = data?.endDate ? formatDateV2(data.endDate, DATETIME_FORMATS.YYYYdotMMdotDD) : "";

  const currentLanguage = getI18nLanguageFromLocalStorage();
  const goDetail = () => {
    saveScrollPosition();
    window.open(`/${currentLanguage}/event-detail/${data.publicId}`, "_self");
  };

  return (
    <div className={classNames("event-card keduall-card flex flex-column cursor-pointer h-full shadow-1")} onClick={goDetail}>
      <div className="event-card__thumb">
        <img src={modifyMediaUrl(data.thumbnailUrl)} alt={data.title} className="w-full height-180 object-cover" />

        {!isExpired ? (
          <Tag value={remainLabel()} severity="info" className="event-card__remain-tag keduall-typography text-16-semibold-600" />
        ) : (
          <div className="event-card__ended-overlay keduall-typography heading-h5-semibold-600">{trans?.eventEndedLabel}</div>
        )}
      </div>

      <div className="flex-1 px-3 flex flex-column justify-content-between">
        <div className="keduall-typography heading-h6-semibold-600 mb-2 three-line-text">{data.title}</div>

        <div className="flex flex-row gap-2 flex-wrap mt-4 mb-1">
          {startDateLabel && (
            <div className="flex-1 flex gap-2 p-2 border-round-lg border-1 border-200">
              <div className="flex align-items-start justify-content-center">
                <i className="pi pi-calendar text-orange-400 surface-100 p-2 border-circle" />
              </div>
              <div>
                <p className="keduall-typography text-14-normal-400">{trans?.START_DATE}</p>
                <p className="keduall-typography text-16-normal-400 font-semibold">{startDateLabel}</p>
              </div>
            </div>
          )}
          {endDateLabel && (
            <div className="flex-1 flex gap-2 p-2 border-round-lg border-1 border-200">
              <div className="flex align-items-start justify-content-center">
                <i className="pi pi-calendar text-orange-400 surface-100 p-2 border-circle" />
              </div>
              <div>
                <p className="keduall-typography text-14-normal-400">{trans?.END_DATE}</p>
                <p className="keduall-typography text-16-normal-400 font-semibold">{endDateLabel}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
